import Nav from "../components/Nav";
import SiteMap from "../components/SiteMap";

export default function DisplayWork() {
    return (
        <>
            <Nav scroll={0} />
            <SiteMap scroll={0} />
        </>
    )
}